import { useTranslation } from "react-i18next";

export default function QuienesSomos()
{
    const { t } = useTranslation();
    return(
        <section className="page-section" id="quienessomos">
            <div className="container">
                <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0" style={{margin:'20px'}}>{t('about_title')}</h2>
                <div className="container">
                <div className="row" style={{margin:'40px'}}>
                    <p className="text-center">{t('about_text1')}</p>
                    <p className="text-center">{t('about_text2')}</p>
                </div>
            </div>
            </div>
        </section>
    )
}